import { render, staticRenderFns } from "./role_management.vue?vue&type=template&id=be1702b6&scoped=true&"
import script from "./role_management.vue?vue&type=script&lang=js&"
export * from "./role_management.vue?vue&type=script&lang=js&"
import style0 from "./role_management.vue?vue&type=style&index=0&id=be1702b6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be1702b6",
  null
  
)

export default component.exports